module.exports = __webpack_public_path__ + "img/faq1.05087be0.png";